import React from 'react';

export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {icon && <div className="text-[48px] mb-4 opacity-40">{icon}</div>}
      <h3 className="text-[16px] font-semibold text-primary-c mb-1">{title}</h3>
      {description && <p className="text-[13px] text-muted-c max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
